import { Box } from '@mui/system';
import {
	BooleanField,
	CreateButton,
	Datagrid,
	ExportButton,
	List,
	NumberField,
	TextField,
	useResourceContext,
} from 'react-admin';

const LifestyleAreaList = () => {
	
	const context = useResourceContext({ resource: 'lifestyle-area/all' });
	return (
		<List
			resource="lifestyle-area/all"
			title={'אזורי אורח חיים'}
			actions={
				<Box>
					<CreateButton resource="lifestyle-area/all" />
					<ExportButton />
				</Box>
			}
		>
			<Datagrid rowClick="edit" resource={context} dir="rtl">
				<TextField source="title.he" label="כותרת" textAlign="right" />
				<NumberField source="order" label="סדר" textAlign="center" />
				<BooleanField source="active" label="פעיל" />
				<BooleanField source="is_tall" label="גבוה" />
			</Datagrid>
		</List>
	);
};

export default LifestyleAreaList;

